export const ApplicationRoutes = {
  Login: '/login',
  LoginTimeout: '/login-timeout',
  Logout: '/logout',
  Root: '/',
  ProjectAll: '/project/all',
  ProjectInfo: '/project/:projectId/info',
  ProjectCreate: '/project/new',
  ProjectEditApplication: '/project/edit/:projectId/application/:applicationId',
  ProjectEdit: '/project/:projectId/edit',
  ProjectInvitationJoin: '/i:address/',
  SystemCreate: '/project/:projectId/application/new',
  ApplicationInfo: '/application/:applicationId/info',
  Settings: '/settings',
  Notification: '/notification',
  LearningRoot: '/learning',
  LearningAnalytics: '/learning/analytics',
  LearningUnitCreate: '/learning/create/:unitId',
  LearningUnitEdit: '/learning/edit/:unitId',
  LearningUnitPassing: '/learning/passing/:passingId',
  LearningUserRating: '/learning/rating/:userId',
  LearningUnitPreview: '/learning/preview/:unitId',
  Analytics: '/analytics',
  AnalyticsProject: '/analytics/projects/:projectId',
  AnalyticsUser: '/analytics/user/:userId',
  ForcePasswordChange: '/force-password-change',
  SSORedirect: '/login/sso/oauth',
  403: '/403',
};
